import { useEffect, useRef } from "react";

import i18next from "i18next";

import { normalizePrice } from "../../../utils";

import { Button, PriceText, Wrapper } from "./style";

const STICKY_BAR_VAR = "--sticky-bar-h";

const MobileFloatingFooter = ({ totalPrice, currency, onContinue, disabled, isLoading, isVisible = true, buttonText }) => {
  const { t } = i18next;
  const wrapperRef = useRef(null);

  const defaultButtonText = buttonText || t("book_and_proceed_to_payment");

  // FE-34: виджет чата и прочие плавающие элементы должны знать реальную высоту
  // панели, иначе они перекрывают сумму и кнопку. Высота зависит от длины текста
  // кнопки и языка, поэтому меряем, а не задаём константой.
  useEffect(() => {
    const node = wrapperRef.current;
    const root = document.documentElement;

    const reset = () => root.style.setProperty(STICKY_BAR_VAR, "0px");

    if (!node || !isVisible) {
      reset();

      return reset;
    }

    const publishHeight = () => root.style.setProperty(STICKY_BAR_VAR, `${Math.round(node.offsetHeight)}px`);

    publishHeight();

    if (typeof ResizeObserver === "undefined") {
      return reset;
    }

    const observer = new ResizeObserver(publishHeight);
    observer.observe(node);

    return () => {
      observer.disconnect();
      reset();
    };
  }, [isVisible]);

  return (
    <Wrapper ref={wrapperRef} $isVisible={isVisible}>
      <PriceText>
        <span className="label">{t("total")}:</span>
        <span className="amount">
          {normalizePrice(totalPrice)} {currency}
        </span>
      </PriceText>
      <Button onClick={onContinue} disabled={disabled || isLoading}>
        {isLoading ? t("processing") : defaultButtonText}
      </Button>
    </Wrapper>
  );
};

export default MobileFloatingFooter;
